/*
 * 機能名：月次締め処理
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdDataTable from '@/components/DdDataTable'
import DdFooterButton from '@/components/DdFooterButton'
import DdYearMonthBoxWithSelector from '@/components/DdYearMonthBoxWithSelector'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import dolly from '@/rahmen/utils/dolly'
import date from '@/ddv2.library/date'

import message from '@/ddv2.library/messages'

export default {
  name: 'BzmKessanGetsuji',
  mixins: [flowMixin],
  data: () => ({
    conditions: {
      taishoYm: '',
      taishoShimeDay: ''
    },
    lastShimeYmd: '',
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdDataTable,
    DdFooterButton,
    DdYearMonthBoxWithSelector
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.taishoShimeYmd) { elem.taishoShimeYmd = filter.dateFormatter(elem.taishoShimeYmd) }
        if (elem.insUserCd) { elem.insUser = elem.insUserCd + ' : ' + elem.insUserNm }
        if (elem.insDate) { elem.insDate = filter.dateYmdHmsFormatter(elem.insDate) }
        return elem
      })
    },
    ExecutionButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    fetchData: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/D2BZMD0010/GetShimeJisseki')
          .then((data) => {
            if (data.payload) {
              var today = new Date()
              this.rows = data.payload.shimeJissekiList
              this.conditions.taishoYm = this.rows.length !== 0 ? this.monthAdd(1, this.rows[this.rows.length - 1].taishoYm + '/01') : ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2)
              this.conditions.taishoShimeDay = data.payload.jishaShimeDay
              this.lastShimeYmd = this.rows.length !== 0 ? filter.dateFormatter(this.rows[this.rows.length - 1].taishoShimeYmd) : ''
              this.clearInvalidMessage(this.$refs)
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            }
            this.Effects.loadComplete()
            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('BzmKessanGetsuji.defineHeaderPromise')
            this.headers = [
              { text: '管理No', value: 'kessanKanriNo' },
              { text: '締め年月日', value: 'taishoShimeYmd' },
              { text: '実施者', value: 'insUser' },
              { text: '実施日時', value: 'insDate' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('BzmKessanGetsuji.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('BzmKessanGetsuji.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('BzmKessanGetsuji.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('BzmKessanGetsuji.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('BzmKessanGetsuji.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
      this.fetchData()
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rows = self.cloneData.rows
            self.conditions = self.cloneData.conditions
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    onExecutionButtonClick: function (e) {
      if (!this.registerValidate()) { return }
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            this.setInvalidSummaryMessage(data.payload.messageCd)
            this.fetchData()
            resolve()
          })
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.initBindVariables()
            // self.transition(0, { id: self.rec.vwJuchuKihon.id })
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    settingTaishoYm: function (p) {
      this.conditions.taishoYm = p
    },
    registerPromise: function () {
      var f = this.HttpClient.post('/api/v1/D2BZMD0010/KessanGetsujiCreate', this.conditions)
      return f
    },
    registerValidate: function () {
      var shimebi = parseInt(this.conditions.taishoShimeDay)
      if ((shimebi >= 32 && shimebi <= 98) || shimebi === 0) {
        this.$refs.taishoShimeDay[this.Ctrls.SET_INVALID_METHOD](message.get('BILV0001'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.conditions.taishoShimeDay !== '99') {
        if (!this.checkDate(this.conditions.taishoYm, this.conditions.taishoShimeDay)) {
          this.$refs.taishoShimeDay[this.Ctrls.SET_INVALID_METHOD](message.get('COME0014', '締日'))
          this.setInvalidSummaryMessage('COME0011')
          return false
        }
      }
      var konkaiShimeYmd = this.conditions.taishoShimeDay !== '99' ? filter.dateFormatter(new Date(this.conditions.taishoYm + '/' + this.conditions.taishoShimeDay)) : date.getLastDate(this.conditions.taishoYm.substring(0, 4), this.conditions.taishoYm.substring(5))
      if (this.lastShimeYmd !== '') {
        if (konkaiShimeYmd <= this.lastShimeYmd) {
          this.$refs.taishoYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0107', ['締め年月日', '最終締め年月日']))
          this.setInvalidSummaryMessage('COME0012')
          return false
        }
      }
      return true
    },
    monthAdd: function (num, date) {
      if (typeof date === 'string') {
        var converted = Date.parse(date)
        var myDate = new Date(converted)
        if (isNaN(myDate)) {
          var arys = date.split('/')
          myDate = new Date(arys[0], --arys[1], arys[2])
        }
        date = myDate
      }
      var resultDate = new Date(date.getTime())
      resultDate.setMonth(date.getMonth() + num)
      if (date.getDate() > resultDate.getDate()) {
        resultDate.setDate(0)
      }

      return ('000' + resultDate.getFullYear()).slice(-4) + '/' + ('0' + (resultDate.getMonth() + 1)).slice(-2)
    },
    checkDate: function (taishoYm, taishoShimeDay) {
      var y = ('0000' + taishoYm.split('/')[0]).slice(-4)
      var targetMonth = ('00' + taishoYm.split('/')[1]).slice(-2)
      var m = targetMonth - 1
      var d = ('00' + taishoShimeDay).slice(-2)
      var date = new Date(y, m, d)
      var resultYear = ('0000' + date.getFullYear()).slice(-4)
      var resultMonth = ('00' + (date.getMonth() + 1)).slice(-2)
      var resultDay = ('00' + date.getDate()).slice(-2)

      console.log(resultYear, resultMonth, resultDay)
      if (resultYear !== y || resultMonth !== targetMonth || resultDay !== d) {
        return false
      }
      return true
    }
  }
}
